import Cookies from 'js-cookie';
import { i18n } from 'src/config/i18n';
import { useHostContext } from 'src/core/hooks/useHostContext';
import { LanguageHelper } from 'src/shared/helpers/language';
const LOCALE = LanguageHelper.normalizeLocale(i18n.language);
const SURROGATE_COOKIE_KEY = 'hmSsoSurrogateExp';
export function useGetContentUrl({ pageId, pageType, classHash, role }) {
    const { product, membershipSlug } = useHostContext();
    const isSurrogateFlow = Boolean(Cookies.get(SURROGATE_COOKIE_KEY));
    const surrogateUrl = `${process.env.APP_CONSUMER_URL}/en/club/auth/surrogate`;
    const baseConsumerUrl = `${process.env.APP_CONSUMER_URL}/${LOCALE}/club/${membershipSlug}`;
    const contentUrl = new URL(`${baseConsumerUrl}/products/${product.id}/${pageType.toLowerCase()}/${pageId}`);
    if (role) {
        contentUrl.searchParams.append('role', role);
    }
    if (classHash) {
        contentUrl.searchParams.append('classHash', classHash);
    }
    if (isSurrogateFlow) {
        return `${surrogateUrl}?redirectTo=${contentUrl.toString()}`;
    }
    return contentUrl.toString();
}
